import { Box, Button } from '@mui/material';
import { useAnalytics } from 'contexts/Analytics/Analytics';
import { usePage } from 'contexts/Page/Page';

export default function WizardButton({ action, color, label, lesson, link, onAction }: WizardButtonProps) {
    const analytics = useAnalytics();
    const page = usePage();

    function handleClick() {
        // Handle action, page change or link
        if (action && onAction) {
            onAction(action);
        } else if (lesson) {
            page.show(lesson);
        } else if (link) {
            window.open(link);
        }

        void analytics.trackActionEvent('action_tool_step_completed', {
            resource_id: lesson || action || label,
            resource_type: 'step',
            source: 'wizard_button',
        });
        if (action === 'finish' || lesson === 'finish') {
            void analytics.trackActionEvent('action_tool_completed', {
                resource_id: lesson || action || 'finish',
                resource_type: 'tool',
                source: 'wizard_button',
            });
        }
    }

    return (
        <Button color={color as any} disableElevation={false} fullWidth onClick={handleClick}>
            <Box component="span" dangerouslySetInnerHTML={{ __html: label }} textAlign="center" />
        </Button>
    );
}
